interface IActivateSimPayload {
    puk: string;
    serviceId: number;
}

export const getStateToPayload = (activationCode: string, selectedServiceId: number): IActivateSimPayload => ({
    puk: activationCode,
    serviceId: selectedServiceId,
});
